<template>
  <ul class="desktime">
    <li
      :class="{ active: now == index }"
      v-for="(item, index) in items"
      :key="index"
      @click="getTime(item, index)"
    >
      {{ item.name }}
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      now: 0,
      items: [
        {
          name: "当月",
        },
        {
          name: "当天",
        },
      ],
    };
  },
  methods: {
    getTime(item, index) {
      this.now = index;
      this.time(index);
    },
    defaultTime() {
      var date = new Date();
      this.yy = date.getFullYear();
      this.mm = date.getMonth();
      this.dd = date.getDate();
      this.time(0);
      this.time(2);
    },
    time(t) {
      if (t == 0) {
        //当月
        this.startTime = new Date(this.yy, this.mm, 1).getTime();
        this.endTime = new Date(this.yy, this.mm + 1, 1).getTime() - 1000;
      } else if (t == 1) {
        //当天
        this.startTime = new Date(this.yy, this.mm, this.dd).getTime();
        this.endTime = new Date(this.yy, this.mm, this.dd + 1).getTime() - 1000;
      } else {
        //当年
        var startTime = new Date(this.yy, 0, 1).getTime();
        var endTime = new Date(this.yy + 1, 0, 1).getTime() - 1000;
        var obj = {
          startTime,
          endTime,
        };
        this.$emit("yytime", obj);
      }
      var obj = {
        startTime: this.startTime,
        endTime: this.endTime,
      };
      this.$emit("time", obj);
    },
  },
  mounted() {
    this.defaultTime();
  },
};
</script>
<style>
.desktime {
  display: flex;
}
.desktime li {
  margin-left: 10px;
}
.desktime li.active,
.desktime li:hover {
  cursor: pointer;
  border-bottom: solid 2px #f63;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/time.vue